import React from 'react'

export const DrawerIcon = ({ width, height }) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 40 36`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.6962 8.5415L23.6962 27.458M13.8749 27.458H26.1268C28.9952 27.458 31.3205 25.1327 31.3205 22.2643V13.8296C31.3205 10.9612 28.9952 8.63584 26.1268 8.63584H13.8749C11.0065 8.63584 8.68115 10.9612 8.68115 13.8296V22.2643C8.68115 25.1327 11.0065 27.458 13.8749 27.458Z" stroke="white"/>
    </svg>
  )
}
